export default {
  getUserCount: {
    method: 'get',
    url: 'stat/user/counter'
  },
  getDeviceCount: {
    method: 'get',
    url: 'stat/device/counter'
  },
  getDeviceModel: {
    method: 'get',
    url: 'stat/device/model'
  },
  getShopCount: {
    method: 'get',
    url: 'stat/shop/counter'
  },
  getBillMonth: {
    method: 'get',
    url: 'stat/bill/month'
  },
  getBillRevenue: {
    method: 'get',
    url: 'stat/bill/revenue'
  },
  getBillShopRank: {
    method: 'get',
    url: 'stat/bill/shop-rank'
  },
  getShopTypeStat: {
    method: 'get',
    url: 'stat/shop/type'
  },

}
